var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        "before-close": _vm.handleClose,
        visible: _vm.isOpen,
        "show-close": true,
        "close-on-click-modal": false,
        width: "800px",
        top: "5vh",
        "custom-class": "modern-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.isOpen = $event
        },
        open: _vm.handleOpen,
      },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "dialog-footer-themed" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "danger",
                        plain: "",
                        size: "medium",
                        icon: "el-icon-circle-close",
                      },
                      on: { click: _vm.handleClose },
                    },
                    [_vm._v("\n        Đóng\n      ")]
                  ),
                  !_vm.showDetail
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            type: "success",
                            size: "medium",
                            icon: "el-icon-circle-check",
                            loading: _vm.loading.submit,
                          },
                          on: { click: _vm.submitForm },
                        },
                        [_vm._v("\n        Lưu lại\n      ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("div", { staticClass: "dialog-header-themed" }, [
        _c("div", { staticClass: "themed-icon" }, [
          _c("i", {
            class: _vm.showDetail ? "el-icon-monitor" : "el-icon-edit",
          }),
        ]),
        _c("div", { staticClass: "themed-text" }, [
          _c("h3", [_vm._v(_vm._s(_vm.title))]),
          _vm.showDetail
            ? _c("p", [
                _vm._v(
                  "Xem chi tiết thông số kết nối và trạng thái của thiết bị nhận diện AI."
                ),
              ])
            : _c("p", [
                _vm._v(
                  "Cập nhật cấu hình mạng, tài khoản modem, hoặc ghi chú của thiết bị nhận diện AI."
                ),
              ]),
        ]),
      ]),
      _c(
        "el-form",
        {
          ref: "recognitionData",
          staticClass: "modern-dialog-form",
          attrs: {
            "label-position": "top",
            model: _vm.devicesData,
            rules: _vm.rules,
          },
        },
        [
          _c(
            "div",
            { staticClass: "form-section" },
            [
              _c("h4", { staticClass: "section-divider" }, [
                _c("i", { staticClass: "el-icon-info" }),
                _vm._v(" Thông tin cơ bản"),
              ]),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Tên thiết bị (Đầu ghi)",
                            prop: "nameDevice",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: _vm.showDetail,
                              placeholder: "Nhập tên đầu ghi",
                            },
                            model: {
                              value: _vm.devicesData.nameDevice,
                              callback: function ($$v) {
                                _vm.$set(_vm.devicesData, "nameDevice", $$v)
                              },
                              expression: "devicesData.nameDevice",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Version điểm danh" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "w-full",
                              attrs: { disabled: _vm.showDetail },
                              model: {
                                value: _vm.devicesData.versionAttendance,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.devicesData,
                                    "versionAttendance",
                                    $$v
                                  )
                                },
                                expression: "devicesData.versionAttendance",
                              },
                            },
                            _vm._l(
                              _vm.listVersionAttendance,
                              function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    value: item.value,
                                    label: item.value,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Loại đầu ghi / Hãng",
                            prop: "typeDevice",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              staticClass: "modern-radio-group",
                              attrs: { disabled: _vm.showDetail },
                              model: {
                                value: _vm.devicesData.typeDevice,
                                callback: function ($$v) {
                                  _vm.$set(_vm.devicesData, "typeDevice", $$v)
                                },
                                expression: "devicesData.typeDevice",
                              },
                            },
                            [
                              _c(
                                "el-radio-button",
                                { attrs: { label: "Hik" } },
                                [_vm._v("Hikvision")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Số Serial Number thiết bị (Device SN)",
                            prop: "deviceSN",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: _vm.showDetail,
                              placeholder: "Nhập số Serial thiết bị",
                            },
                            model: {
                              value: _vm.devicesData.deviceSN,
                              callback: function ($$v) {
                                _vm.$set(_vm.devicesData, "deviceSN", $$v)
                              },
                              expression: "devicesData.deviceSN",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "form-section" },
            [
              _c("h4", { staticClass: "section-divider" }, [
                _c("i", { staticClass: "el-icon-share" }),
                _vm._v(" Cấu hình mạng"),
              ]),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Tên miền (Domain)",
                            prop: "schoolDomain",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: _vm.showDetail,
                              placeholder: "Nhập tên miền",
                            },
                            model: {
                              value: _vm.devicesData.schoolDomain,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.devicesData,
                                  "schoolDomain",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "devicesData.schoolDomain",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "Địa chỉ IP Local", prop: "ipLocal" },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: _vm.showDetail,
                              placeholder: "Nhập IP local",
                            },
                            model: {
                              value: _vm.devicesData.ipLocal,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.devicesData,
                                  "ipLocal",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "devicesData.ipLocal",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Cổng Port Local", prop: "port" } },
                        [
                          _c("el-input-number", {
                            staticClass: "w-full",
                            attrs: {
                              disabled: _vm.showDetail,
                              controls: false,
                              placeholder: "Port Local",
                            },
                            model: {
                              value: _vm.devicesData.port,
                              callback: function ($$v) {
                                _vm.$set(_vm.devicesData, "port", $$v)
                              },
                              expression: "devicesData.port",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Port DVR", prop: "portDVR" } },
                        [
                          _c("el-input-number", {
                            staticClass: "w-full",
                            attrs: {
                              disabled: _vm.showDetail,
                              controls: false,
                              placeholder: "Port DVR",
                            },
                            model: {
                              value: _vm.devicesData.portDVR,
                              callback: function ($$v) {
                                _vm.$set(_vm.devicesData, "portDVR", $$v)
                              },
                              expression: "devicesData.portDVR",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Port RTSP", prop: "portRTSP" } },
                        [
                          _c("el-input-number", {
                            staticClass: "w-full",
                            attrs: {
                              disabled: _vm.showDetail,
                              controls: false,
                              placeholder: "Port RTSP",
                            },
                            model: {
                              value: _vm.devicesData.portRTSP,
                              callback: function ($$v) {
                                _vm.$set(_vm.devicesData, "portRTSP", $$v)
                              },
                              expression: "devicesData.portRTSP",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "form-section" },
            [
              _c("h4", { staticClass: "section-divider" }, [
                _c("i", { staticClass: "el-icon-key" }),
                _vm._v(" Tài khoản thiết bị & Modem"),
              ]),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Tài khoản admin đầu ghi",
                            prop: "adminAcc",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: _vm.showDetail,
                              placeholder: "Nhập tài khoản đầu ghi",
                            },
                            model: {
                              value: _vm.devicesData.adminAcc,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.devicesData,
                                  "adminAcc",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "devicesData.adminAcc",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Mật khẩu admin đầu ghi",
                            prop: "adminPassword",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: _vm.showDetail,
                              type: "password",
                              "show-password": "",
                              placeholder: "Nhập mật khẩu",
                            },
                            model: {
                              value: _vm.devicesData.adminPassword,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.devicesData,
                                  "adminPassword",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "devicesData.adminPassword",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "Tài khoản Modem", prop: "modemAcc" },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: _vm.showDetail,
                              placeholder: "Nhập tài khoản Modem",
                            },
                            model: {
                              value: _vm.devicesData.modemAcc,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.devicesData,
                                  "modemAcc",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "devicesData.modemAcc",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Mật khẩu Modem",
                            prop: "modemPassword",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: _vm.showDetail,
                              type: "password",
                              "show-password": "",
                              placeholder: "Nhập mật khẩu Modem",
                            },
                            model: {
                              value: _vm.devicesData.modemPassword,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.devicesData,
                                  "modemPassword",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "devicesData.modemPassword",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "form-section" },
            [
              _c("h4", { staticClass: "section-divider" }, [
                _c("i", { staticClass: "el-icon-connection" }),
                _vm._v(" Trạng thái kết nối & Webhook"),
              ]),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Địa chỉ MAC thiết bị",
                            prop: "macAddress",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: _vm.showDetail,
                              readonly: "",
                              placeholder:
                                "Nhấp truy xuất để lấy địa chỉ Mac...",
                            },
                            scopedSlots: _vm._u(
                              [
                                !_vm.showDetail
                                  ? {
                                      key: "append",
                                      fn: function () {
                                        return [
                                          _c(
                                            "el-button",
                                            {
                                              staticClass: "fetch-mac-btn",
                                              attrs: { type: "primary" },
                                              on: { click: _vm.handleFetchMac },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-refresh",
                                              }),
                                              _vm._v(
                                                " Truy xuất MAC\n                "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    }
                                  : null,
                              ],
                              null,
                              true
                            ),
                            model: {
                              value: _vm.devicesData.macAddress,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.devicesData,
                                  "macAddress",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "devicesData.macAddress",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { staticClass: "mt-2", attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "status-control-card" }, [
                      _c("span", { staticClass: "control-label" }, [
                        _vm._v("Đăng ký Webhook"),
                      ]),
                      _c(
                        "div",
                        { staticClass: "control-body" },
                        [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type: _vm.devicesData.webhookRegister
                                  ? "success"
                                  : "danger",
                                size: "medium",
                                effect: "light",
                              },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.devicesData.webhookRegister
                                      ? "Đã đăng ký Webhook"
                                      : "Chưa đăng ký"
                                  ) +
                                  "\n              "
                              ),
                            ]
                          ),
                          !_vm.showDetail
                            ? _c(
                                "div",
                                { staticClass: "control-actions" },
                                [
                                  !_vm.devicesData.webhookRegister
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "success",
                                            size: "small",
                                            icon: "el-icon-plus",
                                            loading:
                                              _vm.loading.registerWebhook,
                                          },
                                          on: {
                                            click:
                                              _vm.handleClickRegisterWebhook,
                                          },
                                        },
                                        [_vm._v("Đăng ký")]
                                      )
                                    : _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "danger",
                                            size: "small",
                                            icon: "el-icon-delete",
                                            loading: _vm.loading.deleteWebhook,
                                          },
                                          on: {
                                            click: _vm.handleClickDeleteWebhook,
                                          },
                                        },
                                        [_vm._v("Hủy đăng ký")]
                                      ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "status-control-card" }, [
                      _c("span", { staticClass: "control-label" }, [
                        _vm._v("Trạng thái Hoạt động (Ping)"),
                      ]),
                      _c("div", { staticClass: "control-body" }, [
                        _c(
                          "span",
                          {
                            staticClass: "status-badge",
                            class: _vm.devicesData.active
                              ? "online"
                              : "offline",
                          },
                          [
                            _c("span", { staticClass: "dot" }),
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.devicesData.active ? "Online" : "Offline"
                                ) +
                                "\n              "
                            ),
                          ]
                        ),
                        !_vm.showDetail
                          ? _c(
                              "div",
                              { staticClass: "control-actions" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "primary",
                                      size: "small",
                                      icon: "el-icon-refresh",
                                      loading:
                                        _vm.loading.checkConnectionDevice,
                                    },
                                    on: {
                                      click:
                                        _vm.handleClickCheckConnectionDevice,
                                    },
                                  },
                                  [_vm._v("Kiểm tra kết nối")]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "form-section" },
            [
              _c("h4", { staticClass: "section-divider" }, [
                _c("i", { staticClass: "el-icon-notebook-2" }),
                _vm._v(" Ghi chú"),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "", prop: "note" } },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.showDetail,
                      type: "textarea",
                      rows: 3,
                      placeholder: "Nhập ghi chú thiết bị...",
                    },
                    model: {
                      value: _vm.devicesData.note,
                      callback: function ($$v) {
                        _vm.$set(_vm.devicesData, "note", $$v)
                      },
                      expression: "devicesData.note",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }